import React, { useState } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { api } from '../lib/api';
import { Languages, Copy, ArrowLeftRight } from 'lucide-react';
import { toast } from 'sonner';

const LANGS = ['English','Spanish','French','German','Italian','Portuguese','Japanese','Chinese','Korean','Arabic','Russian','Hindi','Turkish','Vietnamese','Dutch'];

export default function Translator() {
  const [source, setSource] = useState('English');
  const [target, setTarget] = useState('Spanish');
  const [text, setText] = useState('');
  const [out, setOut] = useState('');
  const [loading, setLoading] = useState(false);

  const translate = async () => {
    if (!text.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post('/ai/translate', { text, source, target });
      setOut(data.translation);
    } finally { setLoading(false); }
  };

  const swap = () => { setSource(target); setTarget(source); setText(out); setOut(''); };

  return (
    <div className="max-w-4xl mx-auto space-y-4">
      <div>
        <div className="font-display text-2xl font-bold flex items-center gap-2"><Languages className="w-6 h-6 text-cyan-400" /> Translator</div>
        <p className="text-sm text-slate-400">Translate anything with Jixxeo AI</p>
      </div>
      <div className="flex items-center gap-3">
        <Select value={source} onValueChange={setSource}>
          <SelectTrigger data-testid="tr-source"><SelectValue /></SelectTrigger>
          <SelectContent>{LANGS.map(l => <SelectItem key={l} value={l}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <Button data-testid="tr-swap" variant="outline" size="icon" onClick={swap}><ArrowLeftRight className="w-4 h-4" /></Button>
        <Select value={target} onValueChange={setTarget}>
          <SelectTrigger data-testid="tr-target"><SelectValue /></SelectTrigger>
          <SelectContent>{LANGS.map(l => <SelectItem key={l} value={l}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="glass p-4">
          <Textarea data-testid="tr-input" value={text} onChange={e => setText(e.target.value)} rows={8} placeholder="Enter text to translate" className="border-0 resize-none focus-visible:ring-0" />
        </Card>
        <Card className="glass p-4 relative">
          <Textarea data-testid="tr-output" value={out} readOnly rows={8} placeholder="Translation" className="border-0 resize-none focus-visible:ring-0" />
          {out && <Button data-testid="tr-copy" size="sm" variant="ghost" className="absolute top-2 right-2" onClick={() => { navigator.clipboard.writeText(out); toast.success('Copied'); }}><Copy className="w-3 h-3" /></Button>}
        </Card>
      </div>
      <Button data-testid="tr-translate" onClick={translate} disabled={loading} className="gradient-brand text-white">
        {loading ? 'Translating…' : 'Translate'}
      </Button>
    </div>
  );
}
